/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  GetTransitionAuthorisationResponse,
  PerformTransitionAuthorisationActionRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class TransitionAuthorisationV2Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags transition-authorisation-v-2-controller
   * @name PerformAction
   * @request POST:/api/v2/transition-authorisation/{id}/action/{authorisationAllowedAction}
   */
  performAction = (
    id: string,
    authorisationAllowedAction: 'AUTHORISE' | 'REJECT' | 'WITHDRAW',
    data: PerformTransitionAuthorisationActionRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<GetTransitionAuthorisationResponse, any>({
      path: `/v2/transition-authorisation/${id}/action/${authorisationAllowedAction}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static performActionPath =
    '/v2/transition-authorisation/${id}/action/${authorisationAllowedAction}'
  static performActionMethod = 'POST'
}
